<template>
  <div>
    <div v-if="player">
      <v-container fluid class="white">
        <v-row>
          <v-col cols="12">
            <div class="d-flex flex-grow-1 justify-space-between">
              <h1 class="display-2">{{ player.player.DISPLAY_FIRST_LAST }}</h1>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark v-on="on">{{ perModeMenu }}</v-btn>
                </template>
                <v-btn block @click="togglePerMode('PerGame')">Per Game</v-btn>
                <v-btn block @click="togglePerMode('Totals')">Totals</v-btn>
              </v-menu>
            </div>
            <v-list class="d-flex flex-wrap justify-space-around">
              <PlayerItem v-for="item in playerInfo" :key="item.name" :content="item" />
            </v-list>
            <v-spacer class="d-flex flex-grow-1" width="100%" height="4px"></v-spacer>
          </v-col>
          <v-col cols="12">
            <h1 class="display-1">Career Stats</h1>
            <v-list class="d-flex flex-wrap justify-space-around">
              <CareerStats
                v-for="item in basicStatItem"
                :key="item.header"
                :header="item.header"
                :subHead="item.subHead"
                :stat="item.stat"
              />
            </v-list>
          </v-col>
        </v-row>
      </v-container>
      <v-spacer class="d-flex flex-grow-1 my-4" width="100%"></v-spacer>
      <v-container fluid class="white">
        <v-row>
          <v-col cols="12">
            <StatsTables :playerId="$route.params.playerId"></StatsTables>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-else-if="!error && !player" class="text-center">
      <v-progress-circular size="400" indeterminate color="blue darken-3"></v-progress-circular>
    </div>
    <ErrorMessage v-if="error" message="Player not found!" />
  </div>
</template>

<script>
import config from "@/config";
import ErrorMessage from "@/components/ErrorMessage.vue";
import PlayerItem from "@/components/player/PlayerItem.vue";
import CareerStats from "@/components/player/CareerStats.vue";
import StatsTables from "@/components/player/StatsTables.vue";
import moment from "moment";
import { basicStatItemMixin } from "@/mixins/statItemsMixin";

export default {
  name: "PlayerDetail",
  components: {
    CareerStats,
    ErrorMessage,
    PlayerItem,
    StatsTables
  },
  mixins: [basicStatItemMixin],
  data() {
    return {
      player: null,
      perMode: "PerGame",
      error: false
    };
  },
  computed: {
    birthDate() {
      return this.player
        ? moment(this.player.player.BIRTHDATE).format("MMM Do YYYY")
        : null;
    },
    playerInfo() {
      const { player, birthDate } = this;
      return player
        ? [
            {
              name: "Team",
              value: `${player.player.TEAM_CITY} ${player.player.TEAM_NAME}`
            },
            { name: "Position", value: `${player.player.POSITION}` },
            { name: "Number", value: `${player.player.JERSEY}` },
            { name: "Draft Year", value: `${player.player.DRAFT_YEAR}` },
            { name: "Experience", value: `${player.player.SEASON_EXP}` },
            { name: "Birthday", value: `${birthDate}` }
          ]
        : null;
    },
    perModeMenu() {
      const { perMode } = this;
      if (perMode === "PerGame") {
        return "Per Game";
      }
      return "Totals";
    }
  },
  async mounted() {
    const { getBasicSeasonData } = this;
    getBasicSeasonData();
  },
  methods: {
    async getBasicSeasonData() {
      const { playerId } = this.$route.params;
      const url = `${config.API}players/player/basic/${playerId}/${this.perMode}`;
      try {
        const res = await fetch(url);
        const data = await res.json();

        this.player = data;
      } catch (e) {
        this.error = true;
      }
    },
    togglePerMode(val) {
      this.perMode = val;
      this.getBasicSeasonData();
    }
  }
};
</script>